import { useEffect, useState } from "react";

// Rotating headline word (typewriter-style cycle), inspired by modern agency
// hero sections. Pure JS + CSS, no extra deps.
export default function RotatingWords({ words, className = "", interval = 2200 }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIndex((i) => (i + 1) % words.length), interval);
    return () => clearInterval(id);
  }, [words.length, interval]);

  return (
    <span className={`relative inline-block align-bottom ${className}`}>
      <span key={index} className="rotating-word text-gradient">
        {words[index]}
      </span>
    </span>
  );
}
